

const Partner = () => {
  return (
    <div style={{height:"40vh"}}>


        <h1>Welcome to our Eco-store</h1>
        <br />
      <h2>Become a partner with Us and sell your product</h2>

      <h2>You have to just email us and give your Business details and  phone number :- EcoStore@email.com</h2>
     <br />
      <h2>We will reach You shortly bu verifying your details are geniune</h2>
    </div>
  )
}

export default Partner
